import { SerializedStyles, css } from '@emotion/react';

const container = css({
    overflow: 'hidden',
    border: '1px solid #E6E8EF',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
});

const clickableContainer = css({
    cursor: 'pointer',
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    zIndex: 1,
    color: 'inherit',
    '&:focus': {
        outline: 'none',
    },
    '&:hover': {
        textDecoration: 'none',
    },
});

const image = css({
    width: '100%',
    height: 174,
    objectFit: 'cover',
    objectPosition: 'center center',
    pointerEvents: 'none',
    userSelect: 'none',
});

const contentContainer = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '16px 12px',
    borderRadius: 12,
    position: 'relative',
    zIndex: 2,
    pointerEvents: 'none',
});

const buttonsContainer = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    pointerEvents: 'auto',
});

const getTitleText = (isMobile: boolean): SerializedStyles =>
    css({
        fontWeight: 600,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',

        ...(isMobile && {
            WebkitLineClamp: 1,
        }),
    });

const priceText = css({
    fontWeight: 600,
});

const linkButton = css({
    width: '100%',
    '&:focus': {
        outline: 'none',
    },
    '&:hover': {
        textDecoration: 'underline',
    },
});

const textAndPricesContainer = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});

const pricesContainer = css({
    display: 'flex',
    gap: 4,
});

const basePriceText = css({
    color: '#647491',
    textDecoration: 'line-through',
});

const viewDetailsButton = (newSkin: boolean): SerializedStyles =>
    css({
        padding: '7px 0px',
        color: '#0566FF',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 4,
        ...(!newSkin && {
            fontWeight: 600,
        }),
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            textDecoration: 'underline',
        },
        '& svg': {
            fill: '#0566FF',
            width: 16,
            height: 16,
        },
    });

export default {
    container,
    clickableContainer,
    image,
    contentContainer,
    buttonsContainer,
    getTitleText,
    priceText,
    linkButton,
    textAndPricesContainer,
    pricesContainer,
    basePriceText,
    viewDetailsButton,
};
